import { useCallback } from "react";
import React from "react";
import { STATUS_LIST } from "../../ProjectList/CanvasKanban";
import { ProjectStatus } from "@/components/ProjectConfiguration";
import { STATUS_TYPE_MAPPING, IconType } from "../constants";

interface StatusIconsHook {
  getStatusIcon: (status: string, iconType?: any) => React.ReactElement | null;
}
interface UseStatusIconsProps {
  customProjectStatuses: ProjectStatus[];
}

export const useStatusIcons = ({
  customProjectStatuses,
}: UseStatusIconsProps): StatusIconsHook => {
  const getStatusIcon = useCallback(
    (status: string, iconType: IconType = IconType.ICON) => {
      try {
        const statusObj = STATUS_LIST.find((s) => s.name === status);
        if (statusObj) {
          const iconFunction = statusObj[iconType];
          return iconFunction ? iconFunction() : statusObj.icon();
        }

        const customStatus = customProjectStatuses.find(
          (s) => s.name === status,
        );

        if (customStatus) {
          let parentStatus = STATUS_LIST.find(
            (s) => s.id === customStatus.type,
          );

          if (!parentStatus) {
            const mappedType =
              STATUS_TYPE_MAPPING[
                customStatus.type as keyof typeof STATUS_TYPE_MAPPING
              ];
            if (mappedType) {
              parentStatus = STATUS_LIST.find(
                (status) => status.id === mappedType,
              );
            }
          }

          if (parentStatus) {
            const iconFunction = parentStatus[iconType];
            return iconFunction ? iconFunction() : parentStatus.icon();
          }
        }

        const backlogStatus = STATUS_LIST.find((s) => s.name === "Backlog");
        return backlogStatus?.icon() || null;
      } catch (error) {
        console.error("Error getting status icon:", error);
        return null;
      }
    },
    [customProjectStatuses],
  );

  return { getStatusIcon };
};
